import React from 'react';

export const WeBuyTestimonials: React.FC = () => {
  const testimonials = [
    {
      name: 'Robert Martinez',
      property: '12-Unit Building, Phoenix',
      text: 'I needed to sell quickly due to health issues. They gave me a fair offer and closed in 10 days. The entire process was smooth and professional.',
      rating: 5
    },
    {
      name: 'Jennifer Thompson',
      property: '8-Unit Complex, Denver',
      text: 'After trying to sell with an agent for 6 months, I contacted them. They made an offer in 24 hours and we closed in 2 weeks. Wish I had called them first.',
      rating: 5
    },
    {
      name: 'David Chen',
      property: '24-Unit Building, Seattle',
      text: 'The building needed major repairs and I did not want to deal with it. They bought it as-is and handled everything. Best decision I made.',
      rating: 5
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">What Sellers Say</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real experiences from property owners who sold to us
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg p-8 shadow-md hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed italic">
                {testimonial.text}
              </p>
              <div className="border-t pt-4">
                <p className="font-bold text-lg">{testimonial.name}</p>
                <p className="text-gray-600 text-sm">{testimonial.property}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
